import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import withProductKey from './withProductKey';
import withProduct from './withProduct';
import { findProductVariant } from '../../../../common/utils/product';

const withProductVariant = compose(
  withProductKey,
  withProduct,
  withProps(props => ({
    productVariant: findProductVariant(props.product.variants, props.queryParams)
  })),
);

export default withProductVariant;



// WEBPACK FOOTER //
// ./src/client/js/view/hocs/withProductVariant.js